<template>
	<div ref="watingZone" style="height:100%">
		<div class="card">
			<div class="card-header border-right border-left mr-0 w-100">
				<div class="d-flex justify-content-between pb-0 pt-2 pr-3 pl-3">
					<div>{{ $t('notifications.notifications') }}</div>
					<a v-on:click.prevent="makeAllSeen" class="text-primary" style="cursor: pointer">{{ $t('notifications.make-all-read') }}</a>
				</div>
			</div>
			<div class="card-body y-overflow-scroll " style="height: 370px">
				<div v-if="!notifications || !notifications.length" class="d-flex justify-content-center">
					<span>{{ $t('notification.not-found-any') }}</span>
				</div>
				<div v-else class="d-flex p-1 pb-2 mb-2 border-bottom cursor-inside-div" style="line-height: 16px;" :class="item.isSeen ? '' : 'unseen'" :key="ind" v-for="(item, ind) in notifications" v-on:click="showDescription(item)">
					<div style="display: flow;position: relative">
						<div class="state-item" :class="` ${item.part == 'Chat' ? 'Pledge' : 'Returned'}`" style="border: none !important">
							<i class="circle state-icon violet fad " :class="item.icon" style="font-size: 1.7em;width: 40px;height:40px"></i>
							<icon style="position: relative;top:-10px;right: 0px" :icon="getIcon(item)" />
						</div>
					</div>
					<div class="w-100">
						<div class="d-flex justify-content-between ">
							<div class="d-flex pr-2 ellipsis " style="max-width: 150px;font-size:13px;">
								<label>{{ $t('notifications.sender') + ' :' }}&nbsp;</label>
								<label style=" " v-if="item.part == 'Chat'">{{ item.senderUser.firstName + ' ' + item.senderUser.lastName }}</label>
								<label v-else>{{ $t('notifications.system-message') }}</label>
							</div>
							<div>
								<label data-toggle="tooltip" data-placement="auto right" :title="item.faDate">{{ item.fromNow }}
								</label>
							</div>
						</div>
						<div class="pr-2 text-right">
							<label class="ellipsis mb-1" style="max-width: 240px">{{ item.description }}</label>
						</div>
						<div v-if="item.part != 'Chat'" class="pr-2 d-flex justify-content-start">
							<nk-button class="btn-sm" :options="{ title: $t('notifications.operation') }" v-on:click=previewSourceNotification(item)></nk-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'

	import { mapActions, mapGetters, mapState } from 'vuex'
	import showDescription from './showDescriptionComp'
	import previewCenter from "@/components/form/preview-container"

	export default {
		modal: {
			size: 'sm',
			stateUID: 'notifications',
		},
		props: ['options', 'data'],
		data() {
			return {
				notifications: [],
				fiscals: null,
				selectedRow: null,
				settings: null,
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
				},
			},
			//sa: we have to watch for changes to be updated with state
			'$store.state.notifications.notifications': {
				deep: true,
				immediate: true,
				handler(val) {
					this.notifications = val
				}
			}
		},
		computed: {
			...mapState('appContext', {
				status: (state) => state,
			}),
			...mapGetters({
				get_notifications: 'notifications/all',
			}),

		},
		methods: {
			...mapActions({
				makeSeen: 'notifications/makeNotificationSeen',
			}),
			getIcon(item) {
				return `fa-regular ${item.isSeen ? 'fa-envelope-open' : 'fa-envelope'}`
			},
			makeAllSeen() {
				this.makeSeen(this.get_notifications.filter(x => !x.isSeen).map(x => x.id))
			},
			showDescription(notification) {
				this.makeSeen([notification.id])
				this.showModal({
					component: showDescription,
					data: notification
				}).catch(err => {
				})
			},
			previewSourceNotification(notification) {
				this.showModal({
					component: previewCenter,
					options: { entityType: notification.part, entityId: notification.tag, previewModeAndEditing: true },
					// options: { entityType:'Receive_Cash', entityId: '5dd1c9af-2b33-ed11-8c6d-20689d8178e6',previewModeAndEditing:true},
				}).catch(err => {
				})
			}

		},
	}
</script>
<style>
	.ellipsis {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.unseen {
		/*font-size:12px;*/
		font-weight: 800;
	}

	.cursor-inside-div label {
		cursor: pointer;
	}
</style>